import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function OldSolutions() {
  const failures = [{
    title: 'Recetas sueltas',
    desc: 'Te dejan sola con la pregunta: "¿y mañana qué?"'
  }, {
    title: 'Dietas',
    desc: 'Te llenan de reglas y culpa.'
  }, {
    title: 'Apps',
    desc: 'Te piden registrar y medir cuando lo que te falta es energía mental.'
  }];
  return <Section data-id="element-48">
      <h2 className="text-3xl font-bold mb-6" data-id="element-49">
        Por qué lo que probaste antes no se sostuvo
      </h2>

      <p className="text-lg mb-8 leading-relaxed" data-id="element-50">
        Porque casi todo está diseñado para alguien con más tiempo, más plata,
        más ganas, y una vida que no se desarma.
      </p>

      <div className="space-y-4" data-id="element-51">
        {failures.map((fail, idx) => <div key={idx} className="flex gap-4 p-5 bg-white rounded-xl border-l-4 border-amber shadow-sm" data-id="element-52">
            <XCircle className="w-6 h-6 text-amber mt-1 flex-shrink-0" data-id="element-53" />
            <div data-id="element-54">
              <h3 className="font-bold text-lg mb-1" data-id="element-55">{fail.title}</h3>
              <p className="text-brown-body" data-id="element-56">{fail.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}